import React from 'react';

// Drop-in, dependency-free replacement for react-reveal's <Zoom>.
// Plays a short fade + scale-in once, on mount — no IntersectionObserver,
// no extra package. Respects prefers-reduced-motion automatically.
//
// Usage: <Reveal><h1>Title</h1></Reveal>
const RevealStyles = () => (
    <style>{`
        @keyframes kt-reveal-in {
            from { opacity: 0; transform: scale(0.94); }
            to   { opacity: 1; transform: scale(1); }
        }
        .kt-reveal {
            animation: kt-reveal-in 0.5s ease-out both;
        }
        @media (prefers-reduced-motion: reduce) {
            .kt-reveal { animation: none; }
        }
    `}</style>
);

const Reveal = ({ children, as: Tag = 'div', className = '', delay = 0, ...rest }) => (
    <>
        <RevealStyles />
        <Tag
            className={`kt-reveal ${className}`}
            style={{ animationDelay: `${delay}ms` }}
            {...rest}
        >
            {children}
        </Tag>
    </>
);

export default Reveal;